import { NEWS } from '@/mocks/gossip';

const SITE_LINKS = [
  { label: '话题墙', anchor: 'tagwall' },
  { label: '热搜榜', anchor: 'hot' },
  { label: '最新瓜讯', anchor: 'feed' },
  { label: '事件追踪', anchor: 'track' },
  { label: '常见问答', anchor: 'faq' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const goAnchor = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="border-t-4 border-accent-500 bg-gradient-to-b from-primary-800 to-primary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        {/* 置顶分类条 */}
        <div className="flex flex-wrap items-center gap-x-2 gap-y-3">
          <span className="flex shrink-0 items-center gap-2 pr-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-eye-2-line text-base" aria-hidden="true" />
            </span>
            <span className="font-heading text-xl tracking-widest text-background-50">婚内出轨</span>
          </span>
          <span className="hidden h-6 w-px bg-background-50/20 sm:block" />
          {SITE_LINKS.map((l) => (
            <button
              key={l.anchor}
              type="button"
              onClick={() => goAnchor(l.anchor)}
              className="cursor-pointer whitespace-nowrap rounded-full px-3 py-1 text-sm text-background-50/80 transition-colors hover:bg-primary-700 hover:text-background-50"
            >
              {l.label}
            </button>
          ))}
        </div>

        {/* 快捷内容 + 声明 */}
        <div className="mt-8 grid grid-cols-1 gap-6 border-t border-background-50/15 pt-8 md:grid-cols-3">
          <div className="md:col-span-2">
            <h4 className="flex items-center gap-2 text-sm font-bold text-background-50">
              <i className="ri-flashlight-line text-accent-400" aria-hidden="true" />
              本站热度摘要
            </h4>
            <div className="mt-3 space-y-2">
              {NEWS.slice(0, 3).map((n) => (
                <button
                  key={n.id}
                  type="button"
                  className="group flex w-full cursor-pointer items-center gap-3 text-left"
                >
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-accent-400" />
                  <span className="line-clamp-1 text-xs text-background-50/75 transition-colors group-hover:text-accent-300">
                    {n.title}
                  </span>
                  <span className="ml-auto shrink-0 whitespace-nowrap text-[11px] text-background-50/45">{n.time}</span>
                </button>
              ))}
            </div>
          </div>

          <div>
            <h4 className="flex items-center gap-2 text-sm font-bold text-background-50">
              <i className="ri-shield-check-line text-accent-400" aria-hidden="true" />
              理性吃瓜 · 内容声明
            </h4>
            <p className="mt-3 text-xs leading-6 text-background-50/70">
              本站仅对公开报道信息做整理归档与线索梳理，所有“实锤 / 疑云 / 暗糖 / 爆料”标注均不代表最终定性，亦不构成对任何人的指控。请理性看待未定论内容，不造谣、不传谣、不轻信二手截图。
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              {['不造谣', '不传谣', '理性看待', '只做归档'].map((t) => (
                <span key={t} className="whitespace-nowrap rounded-full bg-primary-700/70 px-2.5 py-1 text-[11px] text-background-50/80">
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* 版权条 */}
        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-5 sm:flex-row">
          <p className="text-xs text-background-50/55">
            © {year} 婚内出轨 · 婚内出轨明星与婚内出轨实锤 全网一手吃瓜资源持续更新中
          </p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-background-50/55">
            <a href="#faq" onClick={(e) => { e.preventDefault(); goAnchor('faq'); }} className="hover:text-background-50">
              免责声明
            </a>
            <a href="#tagwall" onClick={(e) => { e.preventDefault(); goAnchor('tagwall'); }} className="hover:text-background-50">
              线索反馈
            </a>
            <span className="flex items-center gap-1.5">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-70" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
              </span>
              实时追踪中
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}